import { Button, Modal } from "semantic-ui-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import { ReactComponent as Calender } from "../../../images/schedule-calender.svg"
import React, { useState } from "react"
import { setServiceRequestType, updateCart } from "../../../v1/actions/user"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { serviceRequestTypes } from "../../constants"

const LetsScheduleAppointmentModal = ({
  open,
  onClose = () => {},
  continueScheduleText,
  cancelScheduleText,
  continuePath,
  updateCart,
  activeVehicle,
  history,
  setServiceRequestType
}) => {
  const [loading, setLoading] = useState(false)

  const scheduleNow = async () => {
    try {
      setLoading(true)
      await updateCart(
        null,
        activeVehicle.id,
        null,
        undefined,
        {},
        serviceRequestTypes.SCHEDULE_SERVICE
      )
      setLoading(false)
      setServiceRequestType(serviceRequestTypes.SCHEDULE_SERVICE)
      onClose()
      continuePath && history.push(continuePath)
    } catch (error) {
      setLoading(false)
      console.error(error)
    }
  }

  return (
    <Modal open={open} className="let-schedule-appointment-modal">
      <Modal.Content>
        <FontAwesomeIcon icon={faClose} className="close-icon" onClick={onClose} />
        <div className="modal-body">
          <Calender />
          <p className="modal-title">Let's schedule your appointment</p>
          <p className="modal-description">
            Scheduling is required for more complex services and is the best way to secure your
            spot, ensuring the shop is ready for your visit and minimizing your wait.
          </p>
          <Button className="modal-button" onClick={scheduleNow} loading={loading}>
            {continueScheduleText ?? "Yes, schedule now"}
          </Button>
          {cancelScheduleText && (
            <Button className="white-box" onClick={onClose}>
              {cancelScheduleText}
            </Button>
          )}
        </div>
      </Modal.Content>
    </Modal>
  )
}

function mapStateToProps(state) {
  let user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  return {
    activeVehicle
  }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart,
    setServiceRequestType
  })(LetsScheduleAppointmentModal)
)
